export const DIALOGS_CONFIRMATIONS_OPTIONS = [
  {
    id: 'empty-merge-fields-dialog',
    label: 'Missing Fields',
    location: 'Reporter',
    defaultVisible: true,
  },
  {
    id: 'confirm-insert-template',
    label: 'Replace Template',
    location: 'Reporter',
    defaultVisible: true,
  },
] as const;

export type DialogSettingOption = (typeof DIALOGS_CONFIRMATIONS_OPTIONS)[number];
export type DialogId = DialogSettingOption['id'];
export type DialogVisibilityById = Record<DialogId, boolean> & Record<string, boolean>;
export type DialogSettingValue = { id: string; visible: boolean };

export const getDefaultDialogVisibilityById = (): DialogVisibilityById => {
  return DIALOGS_CONFIRMATIONS_OPTIONS.reduce(
    (acc, dialog) => ({
      ...acc,
      [dialog.id]: dialog.defaultVisible,
    }),
    {} as DialogVisibilityById
  );
};

export const getDialogVisibilityById = (
  dialogs: ReadonlyArray<DialogSettingValue> = []
): DialogVisibilityById => {
  return dialogs.reduce((acc, dialog) => {
    acc[dialog.id] = dialog.visible;
    return acc;
  }, getDefaultDialogVisibilityById());
};

export const getDialogsFromVisibilityById = (
  dialogVisibilityById: DialogVisibilityById
): DialogSettingValue[] => {
  const optionsById = new Set<string>(DIALOGS_CONFIRMATIONS_OPTIONS.map((option) => option.id));
  const knownDialogs = DIALOGS_CONFIRMATIONS_OPTIONS.map((option) => ({
    id: option.id,
    visible: dialogVisibilityById[option.id] ?? option.defaultVisible,
  }));
  const customDialogs = Object.entries(dialogVisibilityById)
    .filter(([id]) => !optionsById.has(id))
    .map(([id, visible]) => ({ id, visible }));

  return [...knownDialogs, ...customDialogs];
};
